// extracted by mini-css-extract-plugin
export var data = "personal-information-module--data--9c2b1";
export var image = "personal-information-module--image--97976";
export var mailAt = "personal-information-module--mailAt--98d0c";
export var personalInformation = "personal-information-module--personalInformation--2e8e3";